<template>
  <div class="swipeCard">
    <div class="headTitle">波尼乐学校考勤系统</div>
    <div class="card-bg">
      <div class="info-box">
        <div class="cs-flex input-warpper">
          <span class="card-icon"/>
          <el-input id="card-input" v-model="cardNumber" placeholder="请刷卡或输入卡号" class="card-input flex-1"
                    @keyup.enter.native="onSubmit(2)"/>
        </div>
        <div v-if="list" class="student-box">
          <div class="cs-flex">
            <span v-if="list.student_name" class="w20 fs-weight-bold c-21"
                  :style="{color: list.error ? 'red' : ''}">{{ list.student_name }}</span>
            <span v-if="list.teacher_name" class="w20 fs-weight-bold c-21"
                  :style="{color: list.error ? 'red' : ''}">{{ list.teacher_name }}</span>
            <span v-if="list.course" class="w20 c-70" :style="{color: list.error ? 'red' : ''}">{{
                list.subject
              }}-{{ list.course }}</span>
            <span v-else class="w80 fs-weight-bold" :style="{color: list.error ? 'red' : ''}">{{ list.message }}</span>
            <span v-if="list.course" class="w20 c-70" :style="{color: list.error ? 'red' : ''}">上课时间 {{
                list.start_time
              }}</span>
            <span v-if="list.course" class="w40 c-19ca8e" :style="{color: list.error ? 'red' : ''}">{{
                list.msg
              }} </span>
          </div>
        </div>
        <div v-else class="none-box">
          <img src="../../assets/card/none.png" alt="">
        </div>
      </div>
      <el-tooltip class="front-desk" effect="dark" content="前台打卡" placement="top-start">
        <img :src="pic.desk" alt="" @click="openDesk">
      </el-tooltip>
      <el-tooltip class="front-help" effect="dark" content="求助信息" placement="top-start">
        <img :src="pic.help" alt="" @click="openHelp">
      </el-tooltip>
      <!-- :style="{left: (isChange ? 50 + 'px' : '')}" -->
      <el-tooltip class="operate" effect="dark" content="退出" placement="top-start">
        <img :src="pic.close " alt="" @click="logout">
      </el-tooltip>
      <el-dialog
          title="前台打卡"
          :visible.sync="dialog.isShow"
          :modal="false"
          width="40%"
      >
        <div class="info-box" style="width:100%; padding:0">
          <div class="cs-flex " style=" padding:0">
            <!-- <span class="card-icon" /> -->
            <el-input id="card-input" v-model="deskCardNumber"
                      style="border: 1px solid #DCDFE6 !important;border-radius: 0.285714rem" placeholder="请刷卡或输入卡号"
                      @keyup.enter.native="onSubmit(1)"/>
          </div>
          <div v-if="deskList" class="student-box">
            <div class="cs-flex">
              <span v-if="deskList.student_name" class="w20 fs-weight-bold c-21"
                    :style="{color: deskList.error ? 'red' : ''}">{{ deskList.student_name }}</span>
              <span v-if="deskList.teacher_name" class="w20 fs-weight-bold c-21"
                    :style="{color: deskList.error ? 'red' : ''}">{{ deskList.teacher_name }}</span>
              <span v-if="deskList.course" class="w20 c-70"
                    :style="{color: deskList.error ? 'red' : ''}">{{ deskList.subject }}-{{ deskList.course }}</span>
              <span v-else class="w80 fs-weight-bold" :style="{color: deskList.error ? 'red' : ''}">{{
                  deskList.message
                }}</span>
              <span v-if="deskList.course" class="w20 c-70"
                    :style="{color: deskList.error ? 'red' : ''}">上课时间 {{ deskList.start_time }}</span>
              <span v-if="deskList.course" class="w40 c-19ca8e"
                    :style="{color: deskList.error ? 'red' : ''}">{{ deskList.msg }} </span>
            </div>
          </div>
          <div v-else class="none-box">
            <!-- <img src="../../assets/card/none.png" alt=""> -->
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>

      <el-dialog
          title="求助信息"
          :visible.sync="helpDialog.isShow"
          :modal="false"
          width="40%"
      >
        <div class="info-box" style="width:100%; padding:0">
          <div class="help" v-for="item in helps" :key="item.id">
            {{ item.message }}
            <el-button class="el-button--mini" type="primary" @click="done(item.id)">收到</el-button>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {swipeCard, help, read, done} from '@/api/swipeCard'
import {removeToken} from '@/utils/auth'

export default {
  name: 'SwipeCard',
  data() {
    return {
      cardNumber: '',
      deskCardNumber: '',
      list: null,
      deskList: null,
      isChange: false,
      helps: [],
      pic: {
        open: require('../../assets/card/open.png'),
        close: require('../../assets/card/logout.png'),
        desk: require('../../assets/card/desk.png'),
        help: require('../../assets/card/help.png')
      },
      audio: 'https://up.xwyy.com/202205/1652174282646ZzdMeX.mp3',
      warnAudio: 'https://up.xwyy.com/202408/1724939555640fMPGni.wav',
      dialog: {
        isShow: false
      },
      helpDialog: {
        isShow: false
      }
    }
  },
  created() {
  },
  mounted() {
    var self = this
    document.getElementById('card-input').focus()
    window.setInterval(() => {
      self.getHelp()
    }, 3000)
  },
  methods: {
    openDesk() {
      this.dialog.isShow = true
    },
    openHelp() {
      this.helpDialog.isShow = true
    },
    getHelp() {
      help().then((res) => {
        this.helps = res.data
        let ids = []
        if (this.helps.length > 0) {
          this.helpDialog.isShow = true
        }
        this.helps.forEach((h) => {
          if (parseInt(h.status) === 1) {
            ids.push(h.id)
            //播放语音
            let audio = new Audio()
            audio.src = 'https://up.xwyy.com/202208/1660817637769MG3DJb.mp3'
            audio.play()
          }
        })
        if (ids.length > 0) {
          read({ids: ids.join(',')})
        }
      })
    },
    done(id) {
      done({id: id}).then((res) => {
        this.getHelp()
      })
    },
    logout() {
      removeToken()
      location.reload()
    },
    playAudio() {
      let audio = new Audio()
      audio.src = this.audio
      audio.play()
    },
    playWarnAudio() {
      let audio = new Audio()
      audio.src = this.warnAudio
      audio.play()
    },
    onSubmit(index) {
      const self = this
      if (index === 1) {
        swipeCard({card_no: this.deskCardNumber, teacher: 1}).then(res => {
          self.deskList = res.data
          self.cardNumber = ''
          if (res.data.course) {
            if (res.data.warn) {
              this.playWarnAudio();
            } else {
              this.playAudio()
            }
          }
        })
      } else {
        swipeCard({card_no: this.cardNumber}).then(res => {
          self.list = res.data
          self.cardNumber = ''
          if (res.data.course) {
            if (res.data.warn) {
              this.playWarnAudio();
            } else {
              this.playAudio()
            }
          }
        })
      }
    }
  },


}
</script>

<style lang="scss" scoped>
.swipeCard {
  .headTitle {
    font-size: 50px;
    position: relative;
    top: 100px;
    z-index: 2;
    color: rgb(250, 250, 250);
    text-align: center;
  }

  .card-bg {
    width: 100vw;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url(../../assets/card/bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;


    // z-index: 19999;
    .operate {
      position: absolute;
      left: 250px;
      bottom: 50px;
      width: 80px;
      height: 80px;
      border-radius: 15px;
      box-shadow: 0 0 10px rgb(226, 205, 205);

      &:hover {
        box-shadow: 0 0 10px rgb(206, 195, 195);
      }

      img {
        width: 40px;
        height: 40px;
      }
    }

    .front-desk {
      position: absolute;
      left: 50px;
      bottom: 50px;
      width: 80px;
      height: 80px;
      border-radius: 15px;
      box-shadow: 0 0 10px rgb(226, 205, 205);

      &:hover {
        box-shadow: 0 0 10px rgb(206, 195, 195);
      }

      img {
        width: 40px;
        height: 40px;
      }
    }

    .front-help {
      position: absolute;
      left: 150px;
      bottom: 50px;
      width: 80px;
      height: 80px;
      border-radius: 15px;
      box-shadow: 0 0 10px rgb(226, 205, 205);

      &:hover {
        box-shadow: 0 0 10px rgb(206, 195, 195);
      }

      img {
        width: 40px;
        height: 40px;
      }
    }

    .info-box {
      width: 60%;
      background: rgba(255, 255, 255, .5);
      border-radius: 10px;
      padding: 0 20px;

      .input-warpper {
        border-bottom: 1px solid #999;
        padding-top: 25px;

        .card-icon {
          width: 20px;
          height: 17.5px;
          background: url(../../assets/card/card.png) no-repeat;
          background-size: 100% 100%;
          margin-top: 12px;
        }
      }

      .student-box {
        padding: 20px 0 10px 0;

        span {
          margin-bottom: 10px;
        }

        .w20 {
          width: 20%;
        }

        .w40 {
          width: 40%;
          color: #19CA8E;
        }

        .w80 {
          width: 80%;
          color: #E65F3A;
        }

        .c-21 {
          color: #212121;
        }

        .c-70 {
          color: #707070;
        }
      }

      .none-box {
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .help {
    font-size: 14px;
    line-height: 40px;
    border-bottom: 1px solid #f1f1f1;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/swipeCard/index.vue